import React from 'react'
import { withTranslation } from 'react-i18next'
import { SlideShow } from '../components/Slideshow'

function Index({ t }) {
  return (
    <>
      <div className='uk-child-width-expand@s' data-uk-grid>
        <div className='center-children-x-y'>
          <div className='uk-grid-match'>
            <div className='uk-card uk-card-default uk-border-rounded'>
              <div className='uk-card-header'>
                <div className='uk-grid-small uk-flex-middle' data-uk-grid>
                  <div className='uk-width-expand'>
                    <h1 className='brand-font'>{t('magazine_title')}</h1>
                    <div>
                      <small>ISSN 2066-8988</small> ●{' '}
                      <small>eISSN 2067-144X</small>
                    </div>
                    <small>{t('cavas_research_center')}</small>
                  </div>
                </div>
              </div>

              <div className='uk-card-header'>
                <div className='uk-grid-small uk-flex-middle' data-uk-grid>
                  <div className='uk-width-expand'>
                    <small>
                      <a
                        href='http://www.cncs-nrc.ro/publicatii-stiintifice/'
                        target='_blank'
                        rel='noreferrer'>
                        {t('classification-1')}
                      </a>
                    </small>
                  </div>
                </div>
              </div>

              <div className='uk-card-header'>
                <div className='uk-grid-small uk-flex-middle' data-uk-grid>
                  <div className='uk-width-expand'>
                    <small>{t('indexed-by')}</small>
                    <div>
                      <a
                        href='https://journals.indexcopernicus.com/search/journal/issue?issueId=all&journalId=65753'
                        target='_blank'
                        rel='noreferrer'>
                        <img width='220' src='index/ici2.png' alt='ICI' />
                      </a>
                      <span
                        style={{ display: 'inline-block', width: '20px' }}
                      />
                      <a
                        href='https://www.ceeol.com/search/journal-detail?id=2696'
                        target='_blank'
                        rel='noreferrer'>
                        <img width='190' src='index/ceeol.png' alt='ICI' />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="uk-card-body">
                <h4 className="brand-font">{t('pages.index.latest_release_authors')}</h4>
                <span className="uk-label uk-label-success">1/2020</span>

                <div className="uk-container">
                  <span className="uk-label uk-margin-small-right">Isabelle Huppert</span>
                  <span className="uk-label uk-margin-small-right">Cristian Mungiu</span>
                  <span className="uk-label uk-margin-small-right">Octavian Saiu</span>
                  <span className="uk-label uk-margin-small-right">Radu Jude</span>
                  <span className="uk-label uk-margin-small-right">Alexandru Dabija</span>
                  <span className="uk-label uk-margin-small-right">Irina Margareta Nistor</span>
                  <span className="uk-label uk-margin-small-right">Maia Morgenstern</span>
                  <span className="uk-label uk-margin-small-right">Diana Nechit</span>
                  <span className="uk-label uk-margin-small-right">Cristina Blaga</span>
                  <span className="uk-label uk-margin-small-right">Andrei C. Șerban</span>
                  <span className="uk-label uk-margin-small-right">Oana Marin</span>
                  <span className="uk-label uk-margin-small-right">Anca Boieru</span>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className='uk-grid-match uk-width-1-3@m'>
          <div className='uk-height-large uk-card uk-card-body uk-padding-remove uk-flex uk-flex-center uk-flex-middle'>
            <SlideShow />
          </div>
        </div>
      </div>

      <div data-uk-grid className='uk-margin-top'>
        <div>
          <div className='uk-card uk-card-default uk-border-rounded'>
            <div className='uk-card-body'>
              <p className='uk-dropcap'>{t('pages.index.description')}</p>
            </div>
          </div>
        </div>
      </div>

      <div className='uk-container uk-margin-top'>
        <div>
          <div className='uk-card uk-border-rounded'>
            <div className='uk-card-body uk-padding-small uk-text-center'>
              <p>{t('pages.index.partnership.part1')}</p>
              <h3>{t('pages.index.partnership.part2')}</h3>
              <span className='uk-label uk-margin-small-right'>CAVAS</span>
              <p>{t('pages.index.partnership.part3')}</p>
              <h4 className='uk-margin-remove-bottom'>
                {t('pages.index.partnership.part4')}
              </h4>
              <h4 className='uk-margin-remove-top uk-margin-remove-bottom'>
                {t('pages.index.partnership.part5')}
              </h4>
              <h4 className='uk-margin-remove-top uk-margin-remove-bottom'>
                {t('pages.index.partnership.part6')}
              </h4>
              <h4 className='uk-margin-remove-top uk-margin-remove-bottom'>
                {t('pages.index.partnership.part7')}
              </h4>
              <p>{t('pages.index.partnership.part8')}</p>
              <h4 className='uk-margin-remove-top uk-margin-remove-bottom'>
                {t('pages.index.partnership.part9')}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default withTranslation()(Index)
